export default class S3Utils {
    constructor() { }
    async uploadToS3(url, files, params, token) {
        const promises = [];
        const signedResponses = [];
        const fileNamesAndTypes = files.map(file => ({
            name: file.name,
            type: file.type,
        }));
        const signedUrls = await this.get(url, {
            ...params,
            files: encodeURIComponent(JSON.stringify(fileNamesAndTypes)),
        }, token);
        signedUrls?.map(signedUrl => {
            const file = files.find(f => f.name === signedUrl.file);
            if (file) {
                promises.unshift(this.put(signedUrl.url, file));
                signedResponses.unshift({
                    name: signedUrl.file,
                    dateCreated: signedUrl.dateCreated,
                });
            }
        });
        await Promise.all(promises);
        return signedResponses;
    }
    constructQueryString(params = {}) {
        const requestParams = {
            ...params,
        };
        return ('?' +
            Object.entries(requestParams)
                .map(([key, value]) => `${key}=${value}`)
                .join('&'));
    }
    async downloadFromS3(url, params, token) {
        try {
            const response = await this.get(`${url}`, params, token);
            return response;
        }
        catch (err) {
            console.log('error: ', err);
            return;
        }
    }
    async get(url, params = {}, token) {
        const requestParams = {
            ...params,
        };
        const queryString = this.constructQueryString(requestParams);
        try {
            const response = await fetch(`${url}${queryString}`, token
                ? {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    },
                }
                : undefined);
            if (!response.ok) {
                throw new Error('The api call did not succeed');
            }
            return await response.json();
        }
        catch (e) {
            console.log('error: ', e);
            return;
        }
    }
    async put(url, file) {
        try {
            await fetch(url, {
                method: 'PUT',
                body: file,
            });
        }
        catch (e) {
            return;
        }
    }
    async delete(url, params, token) {
        const response = await this.sendFetch({
            url,
            params,
            token,
            method: 'DELETE',
        });
        return response;
    }
    async sendFetch(fetchParams) {
        const { url, method, token, body, params } = fetchParams;
        const requestParams = {
            ...params,
        };
        const queryString = this.constructQueryString(requestParams);
        const authHeaders = token
            ? {
                Authorization: `Bearer ${fetchParams.token}`,
            }
            : undefined;
        const reqBody = body;
        try {
            const response = await fetch(`${url}${queryString}`, {
                method: method || 'GET',
                headers: authHeaders,
                body: reqBody || undefined,
            });
            if (!response.ok) {
                throw new Error('The api call did not succeed');
            }
            return await response.json();
        }
        catch (e) {
            console.log('error: ', e);
            return;
        }
    }
}
